module.exports = __webpack_public_path__ + "assets/logo-e7a94d.svg";